<script setup>
import NavDrawer from '@/layouts/layout-components/NavDrawer.vue';
import AppBar from '@/layouts/layout-components/AppBar.vue';
</script>

<template>
  <div>
    <app-bar class="bg-primary" />
    <nav-drawer menu="main" />

    <v-main>
      <v-container class="py-0 py-sm-8 px-0 px-sm-6" fluid>
        <router-view />
      </v-container>
    </v-main>
  </div>
</template>

<style scoped>

</style>
